import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MinusIcon, PlusIcon, ShoppingBagIcon, Trash2Icon, XIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { formatPrice } from '../utils/format';
const FREE_SHIPPING = 49;
export function CartDrawer() {
  const {
    isOpen,
    closeCart,
    lines,
    total,
    setQuantity,
    removeLine
  } = useCart();
  const remaining = Math.max(0, FREE_SHIPPING - total);
  return <AnimatePresence data-id="element-16" data-mp="3511rr0p0oiln">
      {isOpen && <div className="fixed inset-0 z-50" role="dialog" aria-modal="true" aria-label="Panier" data-id="element-17" data-mp="350s1dc0289ff">
          <motion.button type="button" aria-label="Fermer le panier" onClick={closeCart} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-0 w-full cursor-default bg-encre/40" data-id="element-18" data-mp="2qbm0zkphkd5y" />

          <motion.aside initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute right-0 top-0 flex h-full w-full max-w-md flex-col bg-creme shadow-2xl" data-id="element-19" data-mp="43hc2gwpie1q">
            <div className="flex items-center justify-between border-b border-encre/10 px-5 py-4" data-id="element-20" data-mp="82q5tlrqybxa">
              <h2 className="font-display text-xl font-extrabold text-encre" data-id="element-21" data-mp="mrm975iuz0rk">Votre panier</h2>
              <button type="button" onClick={closeCart} className="grid h-9 w-9 place-items-center rounded-full text-encre hover:bg-creme-deep" aria-label="Fermer le panier" data-id="element-22" data-mp="htb3n6zljcf5">
                <XIcon className="h-5 w-5" data-id="element-23" data-mp="2xkyucko0o8pi" />
              </button>
            </div>

            {lines.length === 0 ? <div className="flex flex-1 flex-col items-center justify-center gap-4 px-8 text-center" data-id="element-24" data-mp="2tkewfevmd12b">
                <ShoppingBagIcon className="h-10 w-10 text-encre-light" aria-hidden="true" data-id="element-25" data-mp="wk2dchnqiieg" />
                <p className="text-sm text-encre-soft" data-id="element-26" data-mp="11hapo1m7bs7s">
                  Votre panier est vide. Parcourez les pelotes et les créations de l'atelier.
                </p>
                <Link to="/boutique" onClick={closeCart} className="rounded-full bg-framboise px-5 py-2.5 text-sm font-bold text-white hover:bg-framboise-dark" data-id="element-27" data-mp="1bg9uf93uj3pi">
                  Voir la boutique
                </Link>
              </div> : <>
                <ul className="flex-1 overflow-y-auto px-5 py-4" data-id="element-28" data-mp="1p8zjxnil2qrd">
                  {lines.map(line => <li key={line.id} className="flex gap-4 border-b border-encre/8 py-4 last:border-0" data-id="element-29" data-mp="1u686s1eofiyy">
                      <img src={line.image} alt="" className="h-20 w-16 shrink-0 rounded-xl object-cover object-top" data-id="element-30" data-mp="1z7p2zjm7uh97" />
                      <div className="min-w-0 flex-1" data-id="element-31" data-mp="3nndwj774ol4h">
                        <p className="font-display text-base font-bold leading-tight text-encre" data-id="element-32" data-mp="3jmtvvtncizdl">{line.name}</p>
                        <p className="mt-0.5 text-xs text-encre-light" data-id="element-33" data-mp="3eplg1zpo77fi">{line.optionLabel}</p>
                        {line.colorwayName && <p className="mt-1 flex items-center gap-1.5 text-xs font-semibold text-encre-soft" data-id="element-34" data-mp="b83hkivsfcrr">
                            <span className="h-3 w-3 rounded-full ring-1 ring-inset ring-black/10" style={{
                    backgroundColor: line.colorwayHex
                  }} data-id="element-35" data-mp="698qktno2hwk" />
                            {line.colorwayName}
                          </p>}
                        <div className="mt-2.5 flex items-center gap-3" data-id="element-36" data-mp="tzctszwy0fn1">
                          <div className="flex items-center rounded-full border border-encre/15 bg-white" data-id="element-37" data-mp="p7cp6u5xgyk4">
                            <button type="button" onClick={() => setQuantity(line.id, line.quantity - 1)} className="grid h-7 w-7 place-items-center rounded-full text-encre hover:bg-creme-deep" aria-label={`Retirer un ${line.name}`} data-id="element-38" data-mp="9plb76jbs82w">
                              <MinusIcon className="h-3.5 w-3.5" data-id="element-39" data-mp="sft0olu3r00m" />
                            </button>
                            <span className="w-7 text-center text-sm font-bold" data-id="element-40" data-mp="xfxhkcyx9wrd">{line.quantity}</span>
                            <button type="button" onClick={() => setQuantity(line.id, line.quantity + 1)} className="grid h-7 w-7 place-items-center rounded-full text-encre hover:bg-creme-deep" aria-label={`Ajouter un ${line.name}`} data-id="element-41" data-mp="ir1aai4ownrt">
                              <PlusIcon className="h-3.5 w-3.5" data-id="element-42" data-mp="30w2jvcf9fep6" />
                            </button>
                          </div>
                          <button type="button" onClick={() => removeLine(line.id)} className="text-encre-light hover:text-framboise-dark" aria-label={`Supprimer ${line.name}`} data-id="element-43" data-mp="2vw6aexnsmv28">
                            <Trash2Icon className="h-4 w-4" data-id="element-44" data-mp="2hxzwt369vru0" />
                          </button>
                        </div>
                      </div>
                      <p className="shrink-0 font-display text-base font-extrabold text-encre" data-id="element-45" data-mp="2qyo1v8douhur">
                        {formatPrice(line.unitPrice * line.quantity)}
                      </p>
                    </li>)}
                </ul>

                <div className="border-t border-encre/10 bg-white px-5 py-5" data-id="element-46" data-mp="662szi49criw">
                  <div className="flex items-baseline justify-between" data-id="element-47" data-mp="181aozenow8h">
                    <span className="text-sm font-semibold text-encre-soft" data-id="element-48" data-mp="2v1lroyflefjp">Sous-total</span>
                    <span className="font-display text-2xl font-extrabold text-encre" data-id="element-49" data-mp="2zzdrsfqe57yz">
                      {formatPrice(total)}
                    </span>
                  </div>
                  <p className="mt-1.5 text-xs text-encre-light" data-id="element-50" data-mp="390lctw3wccb4">
                    {remaining > 0 ? `Plus que ${formatPrice(remaining)} pour la livraison offerte.` : 'Livraison offerte 🎉 — ou retrait gratuit à Vouziers.'}
                  </p>
                  <button type="button" className="mt-4 w-full rounded-full bg-framboise px-5 py-3.5 font-display text-base font-extrabold text-white transition-colors duration-150 ease-out hover:bg-framboise-dark" data-id="element-51" data-mp="2lazhjjqnah8e">
                    Passer commande
                  </button>
                  <button type="button" onClick={closeCart} className="mt-2 w-full rounded-full px-5 py-2.5 text-sm font-bold text-encre hover:bg-creme-deep" data-id="element-52" data-mp="1xkn45tcmrsaf">
                    Continuer mes achats
                  </button>
                </div>
              </>}
          </motion.aside>
        </div>}
    </AnimatePresence>;
}